import { useEffect, useState } from "react";
import { Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import styles from "./style.module.scss";
import DocumentReferencesEditor from "@components/forms/DocumentReferencesEditor";
import {
    OpenDocumentReferencesPubSub,
    OpenDocumentReferencesPubSubPayload,
} from "@utils/pubsubs/PubSub";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setDocumentReferences } from "@/store/slices/eDocumentSlides";
import { StoredReference } from "@utils/DocumentReferences";

type DocumentReferencesOffCanvasProps = {} & DefaultOffCanvasProps;

const DocumentReferencesOffCanvas = (_props: DocumentReferencesOffCanvasProps) => {
    const dispatch = useAppDispatch();
    const persistedReferences = useAppSelector((state) => state.eDocument.documentReferences);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [readonly, setReadonly] = useState<boolean>(false);
    const [draftReferences, setDraftReferences] = useState<StoredReference[]>([]);

    useEffect(() => {
        const unsubscribe = OpenDocumentReferencesPubSub.subscribe(handleOpenEvent);
        return () => {
            unsubscribe();
        };
    }, [persistedReferences]);

    const handleOpenEvent = (payload: OpenDocumentReferencesPubSubPayload) => {
        const { openOffCanvas = false, readonly: payloadReadonly = false } = payload;
        if (openOffCanvas) {
            setDraftReferences(persistedReferences);
            setReadonly(payloadReadonly);
        }
        setIsOpen(openOffCanvas);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleSave = () => {
        dispatch(setDocumentReferences(draftReferences));
        setIsOpen(false);
    };

    return (
        <DefaultOffCanvas
            className={styles.offCanvas}
            direction="end"
            isOpen={isOpen}
            onClosed={handleClose}
            toggle={() => setIsOpen(false)}
        >
            <OffcanvasHeader className={styles.offCanvasHeader} toggle={handleClose}>
                Referencias del documento
            </OffcanvasHeader>
            <OffcanvasBody className={styles.body}>
                <Container>
                    <DocumentReferencesEditor
                        value={draftReferences}
                        onChange={setDraftReferences}
                        readonly={readonly}
                    />
                </Container>
            </OffcanvasBody>
            <div className={styles.footer}>
                <Button color="secondary" type="button" onClick={handleClose}>
                    Cancelar
                </Button>
                {!readonly && (
                    <Button color="primary" type="button" onClick={handleSave}>
                        Guardar referencias
                    </Button>
                )}
            </div>
        </DefaultOffCanvas>
    );
};

export default DocumentReferencesOffCanvas;
